<template>
  <div class="add-dialog">
    <el-dialog :title="modalTitle" :visible.sync="visible" width="570px" class="addr-modal" :close-on-click-modal="false" :destroy-on-close="false" :before-close="close">
      <div class="addr-form">
        <!-- <el-tabs type="card" v-if="!edit" v-model="customerType" @tab-click="handleClick">
          <el-tab-pane label="国内" name="0"></el-tab-pane>
          <el-tab-pane label="国外" name="1"></el-tab-pane>
        </el-tabs> -->

        <div>
          <div v-if="customerType == '0'">
            <el-form ref="insideForm" :model="formData" :rules="formCheck" label-width="90px">
              <el-row :gutter="12">
                <el-col :span="24">
                  <el-form-item label="国家代码" prop="countryCode">
                    <el-select style="width:425px" v-model="formData.countryCode" placeholder="选择国家代码" :transfer="true" filterable remote reserve-keyword :loading="fetching" :remote-method="val => searchCode(val)" size="small">
                      <el-option v-for="option in countryData" :key="option.iso2" :value="option.iso2" :label="option.iso2">
                        <div style="padding-bottom: 3px; color: #444; font-weight: bold;"><span>{{option.nameEn}}</span><span>（{{option.iso2}}）</span></div>
                        <div style="font-size: 13px; color: #666;"><span>{{option.nameCn}}</span></div>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="公司名称" prop="customerName">
                    <el-input v-model="formData.customerName" size="small" placeholder="请输入公司名称，70个字符以内，不能是中文" maxlength="70" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="详情地址" prop="address">
                    <el-input type="textarea" v-model="formData.address" size="small" placeholder="请输入详情地址" maxlength="140" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="联系电话" prop="contact">
                    <el-input v-model="formData.contact" placeholder="电话号码，纯数字、不能含空格" size="small" maxlength="20" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="实际联系人">
                    <el-input v-model="formData.actualContactPerson" placeholder="请输入联系人" size="small" maxlength="20" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="联系人电话">
                    <el-input v-model="formData.actualContactTel" placeholder="请输入联系人电话" size="small" maxlength="20" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="customerType == '1'">
            <el-form ref="externalForm" :model="formData" :rules="formCheck" label-width="90px">
              <el-row :gutter="12">
                <el-col :span="24">
                  <el-form-item label="国家代码" prop="countryCode">
                    <el-select style="width:425px" v-model="formData.countryCode" placeholder="选择国家代码" :transfer="true" filterable remote reserve-keyword :loading="fetching" :remote-method="val => searchCode(val)" size="small">
                      <el-option v-for="option in countryData" :key="option.iso2" :value="option.iso2" :label="option.iso2">
                        <div style="padding-bottom: 3px; color: #444; font-weight: bold;"><span>{{option.nameEn}}</span><span>（{{option.iso2}}）</span></div>
                        <div style="font-size: 13px; color: #666;"><span>{{option.nameCn}}</span></div>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="城市" prop="city">
                    <el-input v-model="formData.city" size="small" placeholder="请输入城市" maxlength="70" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="州/省" prop="province">
                    <el-input v-model="formData.province" size="small" placeholder="请输入州/省" maxlength="70" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="邮编" prop="postcode">
                    <el-input v-model="formData.postcode" size="small" placeholder="请输入邮编" maxlength="70" show-word-limit></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="公司名称" prop="customerName">
                    <el-input v-model="formData.customerName" size="small" placeholder="请输入公司名称，70个字符以内，不能是中文" maxlength="70" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="详情地址" prop="address">
                    <el-input type="textarea" v-model="formData.address" size="small" placeholder="请输入详情地址" maxlength="140" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="联系人电话">
                    <el-input v-model="formData.actualContactTel" placeholder="请输入联系人电话" size="small" maxlength="20" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="close">取消</el-button>
        <el-button size="mini" type="primary" @click="submitData()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { httpAjax } from "@/api/ajax"
export default {
  name: "AddDialog",
  props: {
    visible: Boolean,
    modalTitle: String,
    customerType: String
  },
  data () {
    return {
      fetching: false,
      formData: {},
      formCheck: {
        customerName: [{ required: true, message: "请输入企业名称", trigger: "change" }],
        address: [{ required: true, message: "请输入企业地址", trigger: "change" }],
        countryCode: [{ required: true, message: "请选择国家代码", trigger: "change" }],
        contact: [
          { required: true, message: "请输入联系电话", trigger: "change" },
          { max: 20, message: '长度过长！长度限制20个数字', trigger: "change" }
        ],
        city: [{ required: true, message: "请输入城市", trigger: "change" }],
        province: [{ required: true, message: "请输入州/省", trigger: "change" }],
        postcode: [{ required: true, message: "请输入邮编", trigger: "change" }],
      },
      countryData: '',
      edit: false
    }
  },
  methods: {
    handEdit (item) {
      this.formData = item
      this.edit = true
    },
    handleClick () {
      let name = this.customerType == '1' ? 'insideForm' : 'externalForm'
      if (!this.edit) {
        this.formData = {}
      }
      this.$refs[name].resetFields()
    },
    // 查询
    searchCode (value) {
      const url = `/services/base/data/country/${value || 'a'}`
      this.fetching = true
      httpAjax({
        url, method: "get",
      }).then((response) => {
        if (response.success) {
          this.countryData = response.data
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
        this.fetching = false
      })
    },

    submitData () {
      let name = this.customerType == '1' ? 'externalForm' : 'insideForm'
      this.$refs[name].validate((valid) => {
        if (valid) {
          const newParams = this.formData
          newParams.type = parseInt(this.customerType)
          httpAjax({
            url: '/services/customer',
            method: this.edit ? 'put' : 'post',
            data: newParams
          }).then((response) => {
            if (response.success) {
              this.$message({
                message: '通知人地址保存成功！',
                type: 'success'
              })
              this.formData = {}
              this.$emit('success')
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
            this.submiting = false
          })
        }
      })
    },
    close () {
      this.formData = {}
      this.$emit('close')
    }
  }
}
</script>
<style scoped  lang="less">
.add-dialog {
  ::v-deep .el-textarea__inner {
    height: 72px;
    overflow-y: auto;
    /* overflow-y: auto;兼容ie  */
  }
  /deep/.el-form .el-form-item .el-form-item__label {
    line-height: 32px !important;
  }
}
</style>
